const TitleResult = ({ customClassName = "text-center md:text-left", isMenuActive, isClickedBtn, totalComposers, totalWorks }) => {
    return (
        <h2 className={`${customClassName}${" text-pgray text-md md:text-lg w-full"}`}>
            Approximately  {' '}
            {isMenuActive === 1 && isClickedBtn === 1 &&
                <>
                    <span className="font-bold mx-1">
                        {totalWorks}
                    </span>
                    {totalWorks > 1 ? ' works ' : ' work '}
            found
                </>
            }
            {isMenuActive === 2 && isClickedBtn === 2 &&
                <>
                    <span className="font-bold mx-1">
                        {totalComposers}
                    </span>
                    {totalComposers > 1 ? ' composers ' : 'composer '}
            found
                </>
            }
        </h2>
    )
}

export default TitleResult;